module.exports = __webpack_public_path__ + "img/consecuencia3.ab4062a2.png";